export default __webpack_public_path__ + "static/media/question.f0fa646e.svg";